import * as React from 'react';
import classNames from 'classnames';
import * as allIcons from '@ant-design/icons';
import ReactIcon from '@ant-design/icons-react';
import createFromIconfontCN from './IconFont';
import { svgBaseProps, withThemeSuffix, removeTypeTheme, getThemeFromTypeName, } from './utils';
import warning from '../_util/warning';
import { getTwoToneColor, setTwoToneColor } from './twoTonePrimaryColor';
// Initial setting
ReactIcon.add(...Object.keys(allIcons).map((key) => allIcons[key]));
setTwoToneColor('#1890ff');
const Icon = (props) => {
    const { 
    // affect outter <i>...</i>
    title, className, onClick, style, 
    // affect inner <svg>...</svg>
    type, component: Component, viewBox, spin, 
    // children
    children, 
    // other
    theme, // default to outlined
    twoToneColor, } = props;
    warning(Boolean(type || Component || children), 'Icon should have `type` prop or `component` prop or `children`.');
    const classString = classNames({
        [`anticon`]: true,
        [`anticon-${type}`]: Boolean(type),
    }, className);
    const svgClassString = classNames({
        [`anticon-spin`]: !!spin || type === 'loading',
    });
    // component > children > type
    if (Component) {
        const innerSvgProps = Object.assign({}, svgBaseProps, { className: svgClassString, viewBox });
        if (!viewBox) {
            delete innerSvgProps.viewBox;
        }
        return (<i className={classString} title={title} style={style} onClick={onClick}>
        <Component {...innerSvgProps}>
          {children}
        </Component>
      </i>);
    }
    if (children) {
        warning(Boolean(viewBox) || React.Children.count(children) === 1 && React.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' +
            ' prop (default `0 0 1024 1024`) to the icon.');
        const innerSvgProps = Object.assign({}, svgBaseProps, { className: svgClassString });
        return (<i className={classString} title={title} style={style} onClick={onClick}>
        <svg {...innerSvgProps} viewBox={viewBox}>
          {children}
        </svg>
      </i>);
    }
    if (typeof type === 'string') {
        let computedType = type;
        if (theme) {
            const alreadyHaveTheme = getThemeFromTypeName(type);
            warning(!alreadyHaveTheme, `This icon already has a theme '${alreadyHaveTheme}'.` +
                ` The prop 'theme' ${theme} will be ignored.`);
        }
        computedType = withThemeSuffix(removeTypeTheme(type), theme || 'outlined');
        return (<i className={classString} title={title} style={style} onClick={onClick}>
        <ReactIcon className={svgClassString} type={computedType} primaryColor={twoToneColor}/>
      </i>);
    }
    return (<i className={classString} title={title} style={style} onClick={onClick}/>);
};
Icon.displayName = 'Icon';
Icon.createFromIconfontCN = createFromIconfontCN;
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
export default Icon;



// WEBPACK FOOTER //
// ./components/icon/index.tsx